export default {
    //mutations主要放的是同步的对数据的改变
    //当mutations很复杂的时候，可以借助Module对mutations,state,actions进行拆分
    changeLook(state,v){
        // console.log(v)
        this.state.isLook = v
    }
}


// WEBPACK FOOTER //
// ./src/vueX/mutations.js